import { render, staticRenderFns } from "./pluginThemeInstaller.vue?vue&type=template&id=b7226b0a&scoped=true&"
import script from "./pluginThemeInstaller.vue?vue&type=script&lang=js&"
export * from "./pluginThemeInstaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7226b0a",
  null
  
)

export default component.exports